(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-collection-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-collection-directory')) {
  customElements.define('aw-collection-directory', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.cards=Array.from(this.querySelectorAll('[data-directory-card]'));
      this.search=this.querySelector('[data-directory-search]');
      this.group='all';this.limit=12;
      this.buttons=Array.from(this.querySelectorAll('button[data-group]'));
      const grid=this.querySelector('[data-directory-grid]');
      this.cards.sort((a,b)=>Number(a.dataset.priority)-Number(b.dataset.priority)||a.dataset.title.localeCompare(b.dataset.title)).forEach(card=>grid.append(card));
      this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.limit=12;this.update();}));
      this.search.addEventListener('input',()=>{this.limit=12;this.update();});
      this.querySelector('[data-directory-more]').addEventListener('click',()=>{const previous=this.visibleCards.length;this.limit+=12;this.update();this.visibleCards[previous]?.focus({preventScroll:true});});
      this.querySelector('[data-directory-reset]').addEventListener('click',()=>{this.group='all';this.search.value='';this.limit=12;this.update();this.search.focus();});
      this.querySelector('[data-directory-tools]').hidden=false;
      this.update();
    }
    normalize(value){return value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();}
    update(){
      const terms=this.normalize(this.search.value).split(' ').filter(Boolean);
      const matches=this.cards.filter(card=>(this.group==='all'||card.dataset.group===this.group)&&terms.every(term=>this.normalize(card.dataset.search).includes(term)));
      this.visibleCards=matches.slice(0,this.limit);
      const visible=new Set(this.visibleCards);
      this.cards.forEach(card=>{card.hidden=!visible.has(card);});
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.group===this.group)));
      this.querySelector('[data-directory-count]').textContent=this.dataset.countTemplate.replace('[shown]',this.visibleCards.length).replace('[total]',matches.length);
      this.querySelector('[data-directory-empty]').hidden=matches.length>0;
      this.querySelector('[data-directory-more]').hidden=matches.length<=this.limit;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-contextual-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const genderCards = document.querySelectorAll('[data-aw-gender-card]');
  if (!genderCards.length) return;
  let preference = 'unisex';
  try {
    const saved = localStorage.getItem('aw_scent_gender');
    if (saved === 'men' || saved === 'women' || saved === 'unisex') preference = saved;
  } catch (error) {}
  genderCards.forEach(card => {
    card.hidden = card.dataset.awGenderCard !== preference;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-code-head"] && !Shopify.designMode) return;
  try {
    const alignFragranceNotes = (scope = document) => {
    const rows = scope.querySelectorAll('.aw-fragrance-notes p:not(:first-child)');

    rows.forEach((row) => {
      if (row.querySelector(':scope > .aw-note-value')) return;

      const label = row.querySelector(':scope > strong');
      if (!label) return;

      const value = document.createElement('span');
      value.className = 'aw-note-value';

      let node = label.nextSibling;
      while (node) {
        const nextNode = node.nextSibling;
        value.appendChild(node);
        node = nextNode;
      }

      row.appendChild(value);
    });
  };

  const populateFragranceProfiles = (scope = document) => {
    const profiles = scope.querySelectorAll('.aw-cro-profile[data-aw-profile-fallback]');

    profiles.forEach((profile) => {
      const productScope = profile.closest('.m-main-product--info, .m-product-quickview, .m-quick-view') || document;
      const source = productScope.querySelector('.aw-fragrance-notes') || document.querySelector('.aw-fragrance-notes');
      const destination = profile.querySelector('[data-aw-profile-notes]');

      if (!source || !destination) return;

      const rows = source.querySelectorAll('p:not(:first-child)');
      const fragments = [];

      rows.forEach((row) => {
        const label = row.querySelector('strong');
        if (!label) return;

        const labelText = label.textContent.trim();
        const value = row.querySelector('.aw-note-value');
        const valueText = value
          ? value.textContent.trim()
          : row.textContent.replace(label.textContent, '').trim();

        if (!valueText || !/^(top|heart|middle|base) notes?:/i.test(labelText)) return;

        const item = document.createElement('div');
        const itemLabel = document.createElement('strong');
        const itemValue = document.createElement('span');

        item.className = 'aw-cro-profile__row';
        itemLabel.textContent = labelText;
        itemValue.textContent = valueText;
        item.append(itemLabel, itemValue);
        fragments.push(item);
      });

      if (!fragments.length) return;

      destination.replaceChildren(...fragments);
      profile.hidden = false;
      profile.removeAttribute('data-aw-profile-fallback');
    });
  };

  const enhanceProductContent = (scope = document) => {
    alignFragranceNotes(scope);
    populateFragranceProfiles(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceProductContent(), { once: true });
  } else {
    enhanceProductContent();
  }

  const fragranceNotesObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (
          node.matches('.aw-fragrance-notes, .aw-cro-profile') ||
          node.querySelector('.aw-fragrance-notes, .aw-cro-profile')
        ) {
          enhanceProductContent(node.parentElement || document);
        }
      });
    });
  });

  fragranceNotesObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  } catch(e) { console.error(e); }
})();

})();
